import {
  FlexColumn,
  FlexRow,
  FullContainer,
  StyledButton,
  StyledSearchBar,
  useLoading,
} from '@gorila-shared-ui/components';
import { areEqual } from 'react-window';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { useFeedback } from '../../../hooks/useFeedback';
import { useStyles } from '../../../hooks/useStyles';
import { updateNotificationSettings } from '../../../services/settingsService';
import { apiParamsState } from '../../../storage/app';
import {
  editingNotificationSettingsState,
  notificationSettingsState,
  searchNotificationSettingsState,
  updateNotificationSettingsState,
} from '../../../storage/settings';
import NotificationSettingsProvider from '../../providers/NotificationSettingsProvider';
import { NotificationSettingsList } from './NotificationSettingsList';

export function NotificationSettingsTab() {
  const { css, classes, theme } = useStyles();
  const { loading, startLoading, stopLoading } = useLoading();
  const apiParams = useRecoilValue(apiParamsState);
  const notificationSettings = useRecoilValue(notificationSettingsState);
  const editingNotificationSettings = useRecoilValue(editingNotificationSettingsState);
  const resetEditingNotificationSettings = useResetRecoilState(editingNotificationSettingsState);
  const [searchNotificationSettings, setSearchNotificationSettings] = useRecoilState(searchNotificationSettingsState);
  const setUpdateNotificationSettings = useSetRecoilState(updateNotificationSettingsState);
  const { showFailFeedback } = useFeedback();

  const onSaveNotificationSettings = async () => {
    if (!apiParams || !editingNotificationSettings) return;
    startLoading();
    const { error } = await updateNotificationSettings(
      apiParams.clientId,
      apiParams.subClientId,
      editingNotificationSettings,
    );
    if (!error) {
      setUpdateNotificationSettings('update');
    } else {
      showFailFeedback(error || 'Ocurrió un error al editar las notificaciones, inténtalo más tarde.');
    }
    stopLoading();
  };

  const hasUpdates = !areEqual(notificationSettings || {}, editingNotificationSettings || {});

  return (
    <FullContainer verticalFlex>
      <FlexColumn
        classNames={css({
          flex: 1,
          overflow: 'hidden',
          [theme.mediaQuery.large]: {
            maxWidth: '60%',
          },
          [theme.mediaQuery.extraLarge]: {
            maxWidth: '50%',
          },
        })}
      >
        <NotificationSettingsProvider />
        <StyledSearchBar
          placeholder="Buscar categoría o notificación"
          onChange={setSearchNotificationSettings}
          value={searchNotificationSettings}
          noMargin
        />
        <NotificationSettingsList />
        <FlexRow classNames={classes.centeredEnd}>
          <StyledButton
            kind="tertiary"
            onClick={resetEditingNotificationSettings}
            disabled={!hasUpdates}
          >
            Restaurar
          </StyledButton>
          <StyledButton
            onClick={onSaveNotificationSettings}
            isLoading={loading}
            disabled={!hasUpdates}
          >
            Guardar
          </StyledButton>
        </FlexRow>
      </FlexColumn>
    </FullContainer>
  );
}
